var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconKakao01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.579.002C3.841.002 0 3.038 0 6.784a6.63 6.63 0 0 0 4.07 5.77c-.179.67-.65 2.427-.744 2.8-.116.467.171.46.359.335.147-.1 2.351-1.6 3.3-2.242q.792.117 1.592.117c4.738 0 8.579-3.037 8.579-6.782S13.315 0 8.577 0"
})));
export default SvgIconKakao01;